// src/pages/SubmitPage.js
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const SubmitPage = () => {
  const { code } = useParams(); // Extract the code from the URL
  const navigate = useNavigate();
  const storedAuth = localStorage.getItem('isAuthenticated');

  useEffect(() => {
    // Save the code in local storage or handle it as needed
    localStorage.setItem('caseId', code);

    // Redirect to the login page
    // console.log(storedAuth);
    if (!storedAuth) {
      navigate('/login');
    } else {
      navigate('/form');
    };
    
  }, [code, navigate]);

  return null; // No UI needed, just redirecting
};

export default SubmitPage;
